import React from 'react';
import { admins } from 'types';

import DialogConfirm from 'components/dialog/dialog-confirm';
import { Row } from 'components/layout/layout';
import { TDialogWrapperComponent } from 'components/dialog/index.types';
import useAdminsDel from '../hooks/use-admins-del';
import { Body1 } from 'components/typography';

const DialogCrudAdminDel = ({
    setIsDialogOpen,
    isDialogOpen,
    asyncStatesHandlers,
    data,
}: { data: admins.TAdmins } & TDialogWrapperComponent) => {
    const [onAdminsDel] = useAdminsDel(asyncStatesHandlers);

    return (
        <DialogConfirm<admins.TAdmins>
            isDialogOpen={data && isDialogOpen}
            setIsDialogOpen={setIsDialogOpen}
            title={'Delete user'}
            onOk={async () => {
                if (!data.id) {
                    console.error('No ID');
                    return;
                }
                try {
                    await onAdminsDel({ id: data.id });
                } catch (e) {}
            }}
        >
            <Row>
                <Body1>Confirm delete of admin with email: {data.email}</Body1>
            </Row>
        </DialogConfirm>
    );
};

export default DialogCrudAdminDel;
